export const MARKER_COLOR_RED: string = 'red';
export const MARKER_COLOR_BLUE: string = 'blue';
